import script from "./DecadeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./DecadeSection.vue?vue&type=script&setup=true&lang=js"

import "./DecadeSection.vue?vue&type=style&index=0&id=2f5d5d3a&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f5d5d3a"]])

export default __exports__